export default __webpack_public_path__ + "static/media/805.77343d50.png";